import React from "react";
import { RichText } from "prismic-reactjs";
import { WEB_SPORTS_MAP } from "../../constants";
import { PreviewStack } from "../PreviewStack";
import { localizeUrl, getArticleAsUrl } from "../../services/UrlService";
import { useQuery } from "@apollo/client";
import { GAMES_TABLE_SIDEBAR_QUERY } from "src/gql/queries";

export type ContentPreviewStackProps = {
  titleText: string;
  linkText: string;
  linkUrl: string;
  sportKey: string;
  sidebarKey: string;
};

export function ContentPreviewStack(props: ContentPreviewStackProps) {
  const { data } = useQuery(GAMES_TABLE_SIDEBAR_QUERY, {
    ssr: false,
    fetchPolicy: "cache-first",
    variables: {
      uid: props.sportKey ? WEB_SPORTS_MAP[props.sportKey].url : undefined,
    },
  });

  let previewItems = [];

  if (data?.prismicGames_table) {
    for (const item of data.prismicGames_table[props.sidebarKey] || []) {
      try {
        let { title = "", image = {} } = item.internal_link || {};
        let imageOverride = item.image?.url;
        let titleOverride = item.title;
        let urlOverride = localizeUrl(item.url?.url || "");

        previewItems.push({
          title: titleOverride || (title ? RichText.asText(title) : ""),
          imageUrl: imageOverride || image?.small?.url || "",
          linkHref: urlOverride || getArticleAsUrl(item.internal_link),
        });
      } catch (error) {
        console.log([
          "Error rendering sidebar element. A field could be missing/incorrect in Prismic or it could be a bug.",
          { item, error },
        ]);
      }
    }
  }

  return (
    <PreviewStack titleText={props.titleText} linkText={props.linkText} linkUrl={props.linkUrl} items={previewItems} />
  );
}
